var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    transform: "translate(-1169 -575)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_304",
    "data-name": "Ellipse 304",
    cx: 35,
    cy: 35,
    r: 35,
    transform: "translate(1169 575)",
    fill: "#004b75",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("g", {
    id: "calendar_18_",
    "data-name": "calendar (18)",
    transform: "translate(1189 595)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M26.135,69.726H3.382A3.385,3.385,0,0,1,0,66.343V46.05a3.385,3.385,0,0,1,3.382-3.382H26.135a3.385,3.385,0,0,1,3.382,3.382V66.343A3.385,3.385,0,0,1,26.135,69.726ZM3.382,44.513A1.539,1.539,0,0,0,1.845,46.05V66.343a1.54,1.54,0,0,0,1.537,1.537H26.135a1.54,1.54,0,0,0,1.537-1.537V46.05a1.539,1.539,0,0,0-1.537-1.537Zm0,0",
    transform: "translate(0 -40.208)",
    fill: "#004c75",
    stroke: "#f2f6f8",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M28.6,172.513H.922a.922.922,0,0,1,0-1.845H28.6a.922.922,0,0,1,0,1.845Zm0,0",
    transform: "translate(0 -160.829)",
    fill: "#004c75",
    stroke: "#f2f6f8",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M107.59,7.379a.923.923,0,0,1-.922-.922V.922a.922.922,0,1,1,1.845,0V6.457A.923.923,0,0,1,107.59,7.379Zm0,0",
    transform: "translate(-100.518)",
    fill: "#004c75",
    stroke: "#f2f6f8",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    "data-name": "Path 1169",
    d: "M374.254,7.379a.923.923,0,0,1-.922-.922V.922a.922.922,0,0,1,1.845,0V6.457A.923.923,0,0,1,374.254,7.379Zm0,0",
    transform: "translate(-351.809)",
    fill: "#004c75",
    stroke: "#f2f6f8",
    strokeWidth: 0.8
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.31d8fff94133dd552b724ba7fde80bab.svg";
export { ForwardRef as ReactComponent };